import React, { useState } from 'react';
import styles from './Setting.module.css';

const BackupSettings = ({ backupStatus, setBackupStatus }) => {
  const [backupFrequency, setBackupFrequency] = useState('daily');
  const [backupType, setBackupType] = useState('full');
  const [backupLocation, setBackupLocation] = useState('cloud');
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(true);

  const handleBackupStart = () => {
    // Perform backup logic here
    setBackupStatus('In Progress...');
    // Simulate backup process
    setTimeout(() => {
      setBackupStatus('Completed');
      alert('Backup Completed Successfully!');
    }, 2000);
  };

  return (
    <div className={styles.sectionContent}>
      <h3>Backup Settings</h3>

      {/* Backup Frequency */}
      <div className={styles.optionContainer}>
        <label>Backup Frequency:</label>
        <select
          value={backupFrequency}
          onChange={(e) => setBackupFrequency(e.target.value)}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      {/* Backup Type */}
      <div className={styles.optionContainer}>
        <label>Backup Type:</label>
        <select
          value={backupType}
          onChange={(e) => setBackupType(e.target.value)}
        >
          <option value="full">Full Backup</option>
          <option value="incremental">Incremental Backup</option>
        </select>
      </div>

      {/* Backup Location */}
      <div className={styles.optionContainer}>
        <label>Backup Location:</label>
        <select
          value={backupLocation}
          onChange={(e) => setBackupLocation(e.target.value)}
        >
          <option value="cloud">Cloud Storage</option>
          <option value="local">Local Storage</option>
          <option value="ftp">FTP/SFTP Server</option>
        </select>
      </div>

     

      {/* Notification */}
      <div className={styles.optionContainer}>
        <label>Enable Backup Notifications:</label>
        <input
          type="checkbox"
          checked={isNotificationEnabled}
          onChange={() => setIsNotificationEnabled(!isNotificationEnabled)}
        />
      </div>

      {/* Start Backup Button */}
      <div className={styles.backupButtonContainer}>
        <button
          className={styles.backupButton}
          onClick={handleBackupStart}
        >
          Start Backup
        </button>
      </div>

      {/* Backup Status */}
      <div className={styles.backupStatus}>
        <p>Status: {backupStatus}</p>
      </div>
    </div>
  );
};

export default BackupSettings;
